import { createContext } from 'react';

const defaultPamData: PrivateAssetManagementContextType = {
  urls: {},
  accountNotFound: false,
  assetManagementData: {
    accounts: [],
    userFullName: '',
    consentUserAgreement: false,
    retailEnabled: false
  }
};

export default createContext(defaultPamData);
